"use client";
import Image from "next/image";
import React from "react";
import { motion } from "framer-motion";
import { ClientProps } from "@/types/clients/clients.type";
import Link from "next/link";

const MarqueeClient = ({ data }: { data: ClientProps[] }) => {
  return (
    <motion.div
      initial={{ x: 0 }}
      animate={{ x: "-100%" }}
      transition={{ duration: 40, repeat: Infinity, ease: "linear" }}
      className="flex flex-shrink-0"
    >
      {[...data, ...data]?.map((client, index) => (
        <Link key={index} href={client.href} target="_blank">
          <Image
            key={index}
            src={client.logo}
            alt={client.name}
            width={150}
            height={100}
            className="h-12 w-32 md:w-44 object-contain mr-6 md:mr-20"
          />
        </Link>
      ))}
    </motion.div>
  );
};

export default MarqueeClient;
